export default "__VITE_ASSET__DAkpYbgw__"